/**
 * FE#444 — is the media of a sent message still there? Answers `ok` / `gone` / `unknown`.
 *
 * - Extension: the page's CSP forbids our bucket, so the HTTP status comes from the background worker.
 * - Web app: a HEAD request from the page. Our bucket's CORS list is short, so a perfectly good file
 *   can still fail here with a network error (status 0). That proves nothing about the file, so it is
 *   `unknown` and the copy is NOT blocked — the send path fetches the media itself and reports a real
 *   failure per message. Only an explicit 403/404/410 counts as gone.
 */
import { isExtensionContext } from '@common/services/detect-context';
import { ContentMessageServiceActions } from '@extension/context/content/services/contentMessageServiceActions';
import { probeResultFromStatus, type AssetProbeResult } from '@common/services/schedule-again';

export async function probeAssetUrl(url: string): Promise<AssetProbeResult> {
    if (isExtensionContext()) {
        return probeResultFromStatus(await ContentMessageServiceActions.probeUrlStatus(url));
    }
    try {
        const response = await fetch(url, { method: 'HEAD' });
        return probeResultFromStatus(response.status);
    } catch {
        return 'unknown';
    }
}
